import SingleToolFooter from '@quicktools/shared-components/components/common/SingleToolFooter/SingleToolFooter';
import TagLines from '@quicktools/shared-components/components/landingPages/TagLines';
import ReviewSnippet from '@quicktools/shared-components/components/landingPages/ReviewSnippet/ReviewSnippet';
import { ImageWithTextList } from '@quicktools/shared-components/components/landingPages/ImageWithTextList';
import InteractiveStepSection from '@quicktools/shared-components/components/landingPages/InteractiveStepSection';
import { ImageWithTextListContained } from '@quicktools/shared-components/components/landingPages/ImageWithTextListContained';
import { ImageWithText } from '@quicktools/shared-components/components/landingPages/ImageWithText';
import Faq from '@quicktools/shared-components/components/landingPages/MinimalFaq';
import { IMG_WITH_TEXT_SIZES } from '@quicktools/shared-components/components/landingPages/constants';
import { useTranslation, Trans } from 'react-i18next';
import cls from 'classnames';

import analytics from '../../services/analytics';
import SimilarTools from '../SimilarTools';

import useStyles from './styles';

function Landing() {
  const { t } = useTranslation();
  const classes = useStyles();
  const taglineItems = [0, 1, 2, 3].map((i) => ({
    text: <Trans i18nKey={`landing.taglines.${i}`} components={{ span: <span /> }} />,
  }));
  const imgList = [0, 1].map((i) => ({
    src: t(`landing.imgs.${i}.src`),
    title: t(`landing.imgs.${i}.title`),
    description: (
      <Trans i18nKey={`landing.imgs.${i}.description`} components={{ span: <span /> }} />
    ),
    sizes: IMG_WITH_TEXT_SIZES,
    srcSet: `${t(`landing.imgs.${i}.mobileSrc`)} 327w, ${t(`landing.imgs.${i}.src`)} 648w`,
  }));

  const steps = [0, 1, 2, 3].map((i) => ({
    title: t(`landing.interactiveSteps.steps.${i}.title`),
    description: t(`landing.interactiveSteps.steps.${i}.description`),
    src: t(`landing.interactiveSteps.steps.${i}.src`),
    mobileSrc: t(`landing.interactiveSteps.steps.${i}.mobileSrc`),
    imgAlt: t(`landing.interactiveSteps.steps.${i}.alt`),
  }));

  const listContainedItems = [0, 1, 2, 3].map((i) => ({
    title: t(`landing.listContained.items.${i}.title`),
    description: (
      <Trans i18nKey={`landing.listContained.items.${i}.description`} components={{ a: <a /> }} />
    ),
    src: t(`landing.listContained.items.${i}.src`),
    alt: t(`landing.listContained.items.${i}.alt`),
  }));

  const textColumns2 = [0, 1, 2, 3].map((i) => ({
    title: t(`landing.img2.columns.${i}.title`),
    description: t(`landing.img2.columns.${i}.description`),
    titleHref: t(`landing.img2.columns.${i}.titleHref`),
  }));

  const textColumns3 = [0, 1, 2, 3].map((i) => ({
    title: t(`landing.img3.columns.${i}.title`),
    description: t(`landing.img3.columns.${i}.description`),
    titleHref: t(`landing.img3.columns.${i}.titleHref`),
  }));

  const faqItems = [0, 1, 2, 3, 4, 5, 6].map((i) => ({
    title: t(`landing.faq.items.${i}.title`),
    description: (
      <Trans i18nKey={`landing.faq.items.${i}.description`} components={{ br: <br /> }} />
    ),
  }));

  return (
    <div className={classes.root}>
      <TagLines className={cls(classes.tagLines, classes.margined)} items={taglineItems} />
      <ImageWithTextList items={imgList} className={classes.margined} inverse />
      <InteractiveStepSection
        title={t('landing.interactiveSteps.title')}
        steps={steps}
        className={classes.margined}
      />
      <ImageWithTextListContained
        className={classes.margined}
        title={<Trans i18nKey="landing.listContained.title" components={{ b: <b /> }} />}
        items={listContainedItems}
      />
      <ImageWithText
        className={classes.margined}
        title={t('landing.img2.title')}
        src={t('landing.img2.src')}
        sizes={IMG_WITH_TEXT_SIZES}
        srcSet={`${t('landing.img2.mobileSrc')} 327w, ${t('landing.img2.src')} 648w`}
        textColumns={textColumns2}
      />
      <ImageWithText
        className={classes.margined}
        src={t('landing.img3.src')}
        sizes={IMG_WITH_TEXT_SIZES}
        srcSet={`${t('landing.img3.mobileSrc')} 327w, ${t('landing.img3.src')} 648w`}
        textColumns={textColumns3}
        imageRight
      />
      <Faq title={t('landing.faq.title')} items={faqItems} />
      <SimilarTools />

      <ReviewSnippet
        ratingValue={4.5}
        ratingCount={223}
        title={t('landing.reviewSnippet.title')}
        subtitle={t('landing.reviewSnippet.subtitle')}
        customClass={classes.reviewSnippet}
      />
      <SingleToolFooter analytics={analytics} />
    </div>
  );
}

export default Landing;
